import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { PROPERTY_KEYS } from '../config';
import { RecoverPasswordForm } from '../forms';
import { InitialPagesLayout } from '../layouts/InitialPagesLayout';
import { selectPropertiesApp } from '../redux';

const keyPrefix = 'pages.RecoverPasswordPage';

export const RecoverPasswordPage = () => {
  const { t } = useTranslation('translation', { keyPrefix });
  const properties = useSelector(selectPropertiesApp);

  /**
   * El backend decide por dónde llega la temporal (`config.send.pwd`). Sin el
   * valor, o con uno desconocido, el texto no nombra ningún medio: prometer el
   * equivocado es peor que no nombrarlo (ADR 0003).
   */
  const sendPwd = properties[PROPERTY_KEYS.SEND_PWD]?.trim().toLowerCase();
  const channel =
    sendPwd === 'whatsapp' || sendPwd === 'email' ? sendPwd : 'neutral';

  return (
    <InitialPagesLayout
      title={t('title')}
      instructions={t(`instructions.${channel}`)}
    >
      <RecoverPasswordForm />
    </InitialPagesLayout>
  );
};
